<template>
  <div class="page-content-wrapper">
    <div class="page-content bg-color">
      <!-- BEGIN PAGE HEADER-->
      <div class="page-bar">
        <ul class="page-breadcrumb">
          <li>
            <i class="fa fa-home"></i>
            <a href="index.html">首页</a>
            <i class="fa fa-angle-right"></i>
          </li>
          <li>
            <a href="#">监控日志</a>
          </li>
        </ul>
      </div>
      <!-- END PAGE HEADER-->
      <div class="search-bar">
        <div class="btn-group" data-toggle="buttons">
          <label class="btn green" :class="{active: biz.type == 1}" @click="changeType(1)">
            <input type="radio" class="toggle" />
            业主出入
          </label>
          <label class="btn green" :class="{active: biz.type == 2}" @click="changeType(2)">
            <input type="radio" class="toggle" />
            授权来访
          </label>
          <label class="btn green" :class="{active: biz.type == 3}" @click="changeType(3)">
            <input type="radio" class="toggle" />
            突然来访
          </label>
        </div>
        
        <div style="display: inline-block;" class="select2-container">
          <select class="form-control" v-model="biz.catalog">
            <option value="0"> 蓝牙门禁 </option>
            <option value="1"> 蓝牙梯控 </option>
          </select>
        </div>
        &nbsp;&nbsp;&nbsp;&nbsp; 地址 
        <div style="display:inline-block" class="select2-container">
          <select @change="changeAddr($event)" id="test-id" class="my-selector form-control  input-small select2">
            <option value=""> 全部地址 </option>
            <option v-for="addr in level1Addrs" :value="addr.addr_id">{{addr.description}}</option>
          </select>
          <span class="select2-arrow" role="presentation"><b role="presentation"></b></span>
        </div>

      </div>
      <div id="search-bar">
        <select id="community_select2" class="form-control select2 select2-allowclear">
          <option v-for="item in communities" :value="item.id">{{item.description}}</option>
        </select>
        <div class="input-prepend input-group search-item" style="margin-left: 3px;">
          <div class="input-prepend input-group">
            <!-- <span class="input-group-addon"><i class="glyphicon glyphicon-calendar fa fa-calendar"></i></span> -->
            <input type="text" placeholder="请选择“访问时间”" readonly style="width: 240px" class="form-control" id="visitorTimeShow" />
            <span class="btn default input-group-addon" @click="clearData">X</span>
          </div>
        </div>
        <!-- <input type="text" placeholder="请选择“访问时间”" class="form-control search-item" data-date-format="yyyy/mm/dd" data-provide="datepicker" name="vTime" v-model="biz.vTime" id="vTime"/> -->
        <input v-show="biz.type == 1" type="text" placeholder="访问者姓名" class="form-control search-item" name="vName" v-model="biz.name" id="vName" />
        <input v-show="biz.type == 3" type="text" placeholder="来访者手机号" class="form-control search-item" name="phoneNum" v-model="biz.phone" id="phoneNum" />
        <button type="button" class="btn blue" style="height: 34px;" @click="search">
          查询
          <i class="fa fa-search"></i>
        </button>
      </div>
      <!-- 业主访问日志 -->
      <table v-show="biz.type == 1" class="table table-striped table-hover table-bordered table-condensed">
        <thead>
          <tr>
            <th width="20%" class="text_overflow">访问时间</th>
            <th width="12%" class="text_overflow">地址</th>
            <th width="15%" class="text_overflow">门禁/梯控</th>
            <th width="12%" class="text_overflow">姓名</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in logs">
            <td class="text_overflow">{{item.access_time}}</td>
            <td class="text_overflow mh">{{item.addr_desc}}</td>
            <td class="text_overflow mh">{{item.lock_desc}}</td>
            <td class="text_overflow">{{item.name}}</td>
          </tr>
        </tbody>
      </table>
      <!-- 授权访客访问日志 -->
      <table v-show="biz.type == 2" class="table table-striped table-hover table-bordered table-condensed">
        <thead>
          <tr>
            <th width="20%" class="text_overflow">访问时间</th>
            <th width="12%" class="text_overflow">地址</th>
            <th width="15%" class="text_overflow">门禁/梯控</th>
            <th width="15%" class="text_overflow">访问者<span class="headtip">(业主填写)</span></th>
            <th width="15%" class="text_overflow">访问单位<span class="headtip">(业主填写)</span></th>
            <th width="10%" class="text_overflow mh">二维码发送人</th>
            <th width="20%" class="text_overflow mh">授权时间</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in logs">
            <td class="text_overflow">{{item.access_time}}</td>
            <td class="text_overflow">{{item.addr_desc}}</td>
            <td class="text_overflow">{{item.lock_desc}}</td>
            <td class="text_overflow">{{item.name}}</td>
            <td class="text_overflow">{{item.destination}}</td>
            <td class="text_overflow mh">{{item.grantor}}</td>
            <td class="text_overflow mh">{{item.expire}}</td>
          </tr>
        </tbody>
      </table>
      <!-- 突然来访访问日志 -->
      <table v-show="biz.type == 3" class="table table-striped table-hover table-bordered table-condensed">
        <thead>
          <tr>
            <th width="20%" class="text_overflow">访问时间</th>
            <th width="12%" class="text_overflow">地址</th>
            <th width="15%" class="text_overflow">开闸岗亭/门禁/梯控</th>
            <th width="15%" class="text_overflow mh">姓名</th>
            <th width="15%" class="text_overflow mh">手机号</th>
            <th width="15%" class="text_overflow mh">门牌号</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in logs">
            <td class="text_overflow">{{item.access_time}}</td>
            <td class="text_overflow">{{item.addr_desc}}</td>
            <td class="text_overflow">{{item.lock_desc}}</td>
            <td class="text_overflow mh">{{item.name}}</td>
            <td class="text_overflow mh">{{item.phone}}</td>
            <td class="text_overflow mh">{{item.remark}}</td>
          </tr>
        </tbody>
      </table>
      <div id="pager-bar">
        <pager :page-index="pageIndex" :page-size="pageSize" :total-count="totalCount" :action="query" @page-change="onPageChange"></pager>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</template>
<script>
import { MSG_ID, K_LOGINED_USER } from '../lib/constant'
import mixins from '../mixins/index'
import http from '../lib/utils/request.js'
import common from '../lib/methods/common.js'
import Pager from '../components/fragment/Pager.vue'
import { mapState } from 'vuex'
import db from '../store/local'

export default {
  mixins: mixins,
  name: 'log',
  components: {
    Pager
  },
  data() {
    return {
      // 列表分页用数据
      pageIndex: 1,
      pageSize: 15,
      totalCount: 0,
      logs: [],
      level1Addrs: [],
      biz: {
        type: 1,
        addr_ids: [],
        mac: '',
        name: '',
        phone: '',
        time_start: 0,
        time_end: 0,
        visitorTimeShow: '',
        catalog: 0
      },
      communities: []
    }
  },
  methods: {
    onPageChange(pageIndex) {
      this.query()
    },
    search() {
      this.query()
    },
    query() {
      let that = this
      let $my = window.$('select.my-selector').last()
      if (!$my.val()) {
        this.biz.addr_ids = $my.prev().val() ? [$my.prev().val()] : []
      } else {
        this.biz.addr_ids = $my.val() ? [$my.val()] : []
      }
      let reqdata = {
        page_index: this.pager.pageIndex, // this.pager.pageIndex
        page_size: this.pageSize,
        type: this.biz.type,
        catalog: this.biz.catalog,
        name: this.biz.name,
        phone: this.biz.phone,
        time_start: this.biz.time_start,
        time_end: this.biz.time_end,
        addr_ids: this.biz.addr_ids,
        uid: db.get(K_LOGINED_USER).account.id,
        community_id: window.$('#community_select2').select2('val')
      }
      http.post('log.pageLog', reqdata, { session: this.session() }, function(data) {
        that.logs = data.content
        that.totalCount = data.total_count
      }, (res) => {
        console.log(res)
      })
    },
    fill() {
      let reqdata = { parent_addr_id: '0', page_index: 1, page_size: 500, uid: db.get(K_LOGINED_USER).account.id }
      http.invoke('addr.pageAddr', reqdata, (data0) => {
        this.level1Addrs = data0.content
      })
    },
    changeType(type) {
      this.logs = []
      this.totalCount = 0
      this.pager.pageIndex = 1
      this.biz.type = type
    },
    clearData() {
      console.log('oo')
      this.biz.time_start = 0
      this.biz.time_end = 0
      window.$('#visitorTimeShow').val('')
      this.setupDatePicker()
    },
    setupDatePicker() {
      window.$('#visitorTimeShow').daterangepicker({
        timePicker: true,
        timePickerIncrement: 30,
        format: 'YYYYMMDD HH:mm',
        showDropdowns: true,
        timePicker12Hour: false,
        startDate: window.moment().subtract('days', 1),
        endDate: window.moment(),
        autoUpdateInput: false,
        alwaysShowCalendars: true,
        linkedCalendars: true,
        locale: {
          applyLabel: '确定',
          cancelLabel: '取消',
          fromLabel: '起始时间',
          toLabel: '结束时间',
          customRangeLabel: '自定义',
          daysOfWeek: ['日', '一', '二', '三', '四', '五', '六'],
          monthNames: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
          firstDay: 1
        },
        ranges: {
          '最近1小时': [window.moment().subtract('hours', 1), window.moment()],
          '今日': [window.moment().startOf('day'), window.moment()],
          '昨日': [window.moment().subtract('days', 1).startOf('day'), window.moment().subtract('days', 1).endOf('day')],
          '最近7日': [window.moment().subtract('days', 6), window.moment()],
          '最近30日': [window.moment().subtract('days', 29), window.moment()],
          '本月': [window.moment().startOf('month'), window.moment().endOf('month')],
          '上个月': [window.moment().subtract(1, 'month').startOf('month'), window.moment().subtract(1, 'month').endOf('month')]
        }
      }, (start, end) => {
        this.biz.time_start = (start._d.getTime())
        this.biz.time_end = (end._d.getTime())
      })
    },
    changeAddr(event) {
      this.appendSelect(event.target)
    },
    appendSelect(elem) {
      let $sel = window.$(elem)
      while (true) {
        let s = $sel.next()
        if (s[0]) {
          s.remove()
        } else {
          break
        }
      }
      let $newSel = $sel.clone()
      $newSel.empty().change((evt) => {
        this.appendSelect(evt.target)
      })
      let reqdata = { parent_addr_id: $sel.val(), page_index: 1, page_size: 500 }
      http.post('addr.pageAddr', reqdata, {}, (data) => {
        $newSel.append(window.$('<option value="">-</option>'))
        for (let addr of data.content) {
          $newSel.append(window.$('<option value="' + addr.addr_id + '">' + addr.description + '</option>'))
        }
        if (data.content.length > 0) {
          $sel.parent().append($newSel)
        }
      }, () => {})
    },
    ...common
  },
  computed: {
    ...mapState({
      pager: state => state.pager
    })
  },
  created() {
    this.$router.afterEach((to, from) => {
      window.emitter.emit(MSG_ID.MSG_UI_FIX_CONTENT_HEIGHT)
    })
    this.$router.beforeEach((to, from, next) => {
      window.emitter.emit(MSG_ID.MSG_UI_FIX_CONTENT_HEIGHT)
      next()
    })
    window.emitter.on(MSG_ID.MSG_UI_FIX_CONTENT_HEIGHT, (...args) => {
      setTimeout(() => {
        return window.Layout && window.Layout.fixContentHeight()
      }, 50)
    })
  },
  mounted() {
    this.communities = db.get(K_LOGINED_USER).account.communities
    window.$('#community_select2').select2({
      placeholder: '选择项目...',
      allowClear: false
    })
    setTimeout(() => {
      window.$('#community_select2').select2('val', this.communities[0].id)
    }, 300)
    this.setupDatePicker()
    this.query()
    this.fill()
    // window.emitter.emit(MSG_ID.MSG_UI_INFLATE_SELECT2, '#test-id')
    // window.$('#test-id').select2({
    //   placeholder: '请选择一项',
    //   allowClear: true
    // })
    // window.$('#test-id').on('change', (e) => {
    //   console.log(e)
    // })
    // window.$('#test-id').on('select2:select', (e) => {
    //   console.log('select2:select')
    // })
    // window.$('#test-id').on('select2:open', (e) => {
    //   console.log('select2:open')
    // })
    // window.$('#test-id')
    //   .select2()
    //   .on('change',(event) => { this.appendSelect(event.target) })
    // .on('select2-opening', function () { log('opening') })
    // .on('select2-open', function () { log('open') })
    // .on('select2-close', function () { log('close') })
    // .on('select2-highlight', function (e) { log('highlighted val=' + e.val + ' choice=' + JSON.stringify(e.choice)) })
    // .on('select2-selecting', function (e) { log('selecting val=' + e.val + ' choice=' + JSON.stringify(e.choice)) })
    // .on('select2-removing', function (e) { log('removing val=' + e.val + ' choice=' + JSON.stringify(e.choice)) })
    // .on('select2-removed', function (e) { log('removed val=' + e.val + ' choice=' + JSON.stringify(e.choice)) })
    // .on('select2-loaded', function (e) { log('loaded (data property omitted for brevity)') })
    // .on('select2-focus', function (e) { log('focus') })
    // .on('select2-blur', function (e) { log('blur') })
  }
}
</script>
<style scoped>
.bg-color {
  background-color: #fff;
}

.top-tip {
  float: left;
  top: 0;
  left: 0;
  z-index: 20000;
  background-color: #f00;
}

#pager-bar {
  text-align: center;
}

.table th {
  text-align: center;
}

.table {
  vertical-align: middle;
  text-align: center;
}

#search-bar {
  height: 60px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.search-item {
  flex-grow: 1;
  margin-right: 3px;
  /* padding-right: 70px; */
}

.dataS {
  margin-right: 3px;
  width: 100%;
  border: 0.5px solid #e5e5e5;
  display: table;
}

.my-selector {
  display: inline;
  max-width: 150px;
}

@media screen and (max-width: 767px) {
  .mh {
    display: none;
  }
}

.headtip {
  font-size: 10px;
  font-weight: normal;
  color: green;
}
</style>


// WEBPACK FOOTER //
// MonitorLog.vue?a0b7c3fc